var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footermain"},_vm._l((_vm.tabs),function(tab){return _c('div',{key:tab.path,staticClass:"f_div",class:{selectf_div: _vm.isActive(tab)},on:{"click":function($event){return _vm.toLinkUrl(tab.path)}}},[_c('img',{attrs:{"src":_vm.isActive(tab) ? tab.iconOn : tab.iconOff}}),_c('span',[_vm._v(_vm._s(tab.text))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }